import * as React from 'react';
import { Button, Checkbox, Col, Form, Input, Row } from 'antd';
import Link from 'antd/lib/typography/Link';
import { checkEmailIsDuplicated } from '../../api/constlink';
import PasswordValidator from 'password-validator';
import Title from 'antd/lib/typography/Title';

interface SignupStep1Props {
  isMobileApp: boolean;
  userData: any;
  onSuccess: (data: any) => void;
}

function SignupStep1({ isMobileApp, userData, onSuccess }: SignupStep1Props) {
  const [form] = Form.useForm();
  const _checkEmailIsDuplicated = async (email: string) => {
    const res = await checkEmailIsDuplicated({
      data: {
        email,
      },
    });
    if (res.isDuplicate) return Promise.reject('중복된 이메일이 존재 합니다.');
    else return Promise.resolve();
  };

  const validatePassword = (value: string) => {
    const schema = new PasswordValidator();
    schema
      .is()
      .min(8)
      .is()
      .max(20)
      .has()
      .uppercase()
      .has()
      .lowercase()
      .has()
      .digits(1)
      .has()
      .not()
      .spaces();

    if (!value) {
      return Promise.reject(new Error('비밀번호는 필수 항목입니다.'));
    }

    if (!schema.validate(value)) {
      return Promise.reject(
        new Error(
          // '영문 대 소문자, 숫자, 특수문자를 조합한 8자 이상이어야 합니다.',
          '영문 대 소문자, 숫자를 조합한 8자 이상이어야 합니다.',
        ),
      );
    }
    return Promise.resolve();
  };

  const validatePassword2 = (value: string) => {
    if (
      form.getFieldValue('password') &&
      form.getFieldValue('password') !== value
    ) {
      return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
    }
    return Promise.resolve();
  };

  const handleOpenNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener, noreferrer');
  };

  return (
    <>
      <Row justify={'center'} style={{ marginTop: '10px' }}>
        <Col>
          <Title level={4}>하이공사에 로그인할 계정을 만들어 주세요.</Title>
        </Col>
      </Row>
      <Form
        name="basic"
        form={form}
        layout="vertical"
        initialValues={userData}
        onFinish={onSuccess}
      >
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="name"
              label="이름"
              rules={[
                {
                  required: true,
                  message: '이름을 입력 하세요.',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        {/* <Form.Item label="연락처(개인)">
        <Row>
          <Col span={16}>
            <Row>
              <Col span={16} style={{ marginRight: '10px' }}>
                <Form.Item
                  name="personalPhone"
                  rules={[
                    {
                      required: true,
                      message: '이름을 입력 하세요.',
                    },
                  ]}
                >
                  <Input
                    placeholder="개인 휴대전화 번호를 입력하세요."
                    name="personalPhone"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Button>인증요청</Button>
              </Col>
            </Row>
            <Row>
              <Col span={16} style={{ marginRight: '20px' }}>
                <Input
                  type="text"
                  placeholder="인증번호를 입력하세요."
                  name="verificationCode"
                />
              </Col>
              <Col span={6}>
                <Button>인증확인</Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form.Item> */}

        <div></div>

        {/* <Row justify="center">
          <Col span={18}>
            <Form.Item
              label="연락처(개인)"
              name="personalPhone"
              rules={[
                {
                  required: true,
                  message: '이름을 입력 하세요.',
                },
              ]}
            >
              <Input
                placeholder="개인 휴대전화 번호를 입력하세요."
                name="personalPhone"
              />
            </Form.Item>
          </Col>
        </Row> */}

        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="email"
              label="이메일"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '이메일을 입력 하세요.',
                },
                {
                  type: 'email',
                  message: '이메일 입력이 잘못 되었습니다.',
                },
                {
                  validator: (_, value) => _checkEmailIsDuplicated(value),
                },
              ]}
            >
              <Input type="email" placeholder="이메일" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="password"
              label="비밀번호"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
                {
                  validator: (_, value) => validatePassword(value),
                },
              ]}
            >
              <Input.Password placeholder="새 비밀번호" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="password2"
              label="비밀번호 확인"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력 하세요.',
                },
                {
                  validator: (_, value) => validatePassword2(value),
                },
              ]}
            >
              <Input.Password type="password" placeholder="새 비밀번호 확인" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="isTermsOfServiceEnabled"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            '서비스 이용약관을 확인 및 동의 부탁드립니다.',
                          ),
                        ),
                },
              ]}
            >
              <Checkbox style={{ width: '100%' }}>
                (필수){' '}
                <Link
                  onClick={() => {
                    const url =
                      'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/HIGONGSA+-+%E1%84%89%E1%85%A5%E1%84%87%E1%85%B5%E1%84%89%E1%85%B3%E1%84%8B%E1%85%B5%E1%84%8B%E1%85%AD%E1%86%BC%E1%84%8B%E1%85%A3%E1%86%A8%E1%84%80%E1%85%AA%E1%86%AB.html';
                    if (isMobileApp) {
                      // @ts-ignore
                      openWebPage.postMessage(url);
                    } else {
                      handleOpenNewTab(url);
                    }
                  }}
                >
                  서비스 이용약관
                </Link>{' '}
                을 확인하였고, 이에 동의합니다.
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}>
            <Form.Item
              name="isPrivacyPolicyEnabled"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error(
                            '개인정보처리방침을 확인 및 동의 부탁드립니다.',
                          ),
                        ),
                },
              ]}
            >
              <Checkbox style={{ width: '100%' }}>
                (필수){' '}
                <Link
                  onClick={() => {
                    const url =
                      'https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/HIGONGSA+-+%E1%84%80%E1%85%A2%E1%84%8B%E1%85%B5%E1%86%AB%E1%84%8C%E1%85%A5%E1%86%BC%E1%84%87%E1%85%A9%E1%84%8E%E1%85%A5%E1%84%85%E1%85%B5%E1%84%87%E1%85%A1%E1%86%BC%E1%84%8E%E1%85%B5%E1%86%B7.html';
                    if (isMobileApp) {
                      // @ts-ignore
                      openWebPage.postMessage(url);
                    } else {
                      handleOpenNewTab(url);
                    }
                  }}
                >
                  개인정보처리방침
                </Link>{' '}
                을 확인하였고, 이에 동의합니다.
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={18}></Col>
        </Row>

        <Row justify="center">
          <Col span={8}>
            <Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                style={{ width: '100%' }}
                disabled={
                  form.getFieldsError().filter(({ errors }) => errors.length)
                    .length > 0
                }
              >
                다음
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default SignupStep1;
